import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    userRole:[]
}

export const fetchuserRole = createAsyncThunk('userRole/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/userRole`)
    return response.data
  })


let userSlice = createSlice({
  name:'userRole',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchuserRole.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchuserRole.fulfilled,(state,action)=>{
          state.isLoading = false
          state.userRole = action.payload
      })
      .addCase(fetchuserRole.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;